<section class="creditcard-form d-flex w-100 p-3 justify-content-center">
    <div class="d-flex flex-column align-items-center h-100 w-100">
        <div class="w-100">
            <app-back-button url="/cart">BACK TO CART</app-back-button>
        </div>
        <div class="d-flex form-container flex-column-reverse flex-md-row">
            <app-sprintpay-credit-card-form
                (adyenCardAdded)="responseAdyen($event?.adyenResponse ?? null)"
                [addPersonalForm]="false"
            >
                <ng-template let-creditCardForm>
                    <div class="d-flex container-buttons align-items-end">
                        <button id="cancel" type="button" mat-button color="primary" (click)="back()">CANCEL</button>
                        <button
                            id="submit"
                            type="submit"
                            mat-flat-button
                            class="ms-3 p-1 py-md-0 px-md-3"
                            color="primary"
                        >
                            {{ loading ? 'LOADING' : 'ADD PAYMENT METHOD' }}
                            @if (loading) {
                                <mat-icon class="ms-2 spinner-icon" iconPositionEnd>
                                    <mat-spinner diameter="16" />
                                </mat-icon>
                            }
                        </button>
                    </div>
                </ng-template>
                <ng-template #cancelButtonTemplateRef let-creditCardForm>
                    <div class="d-flex container-buttons align-items-end">
                        <button id="cancel" type="button" mat-button color="primary" (click)="enableForm()">
                            CANCEL
                        </button>
                    </div>
                </ng-template>
            </app-sprintpay-credit-card-form>
        </div>
    </div>
</section>
